/* global window */
const merge = require('lodash/merge');
const restclient = require('nordic/restclient');
const { canUseDOM } = require('../../app/lib/dom-utils');

const DEFAULT_RESTCLIENT_OPTIONS = {
  headers: {
    common: {
      'X-Requested-With': 'XMLHttpRequest',
      ...(canUseDOM
        && window.MobileWebKit
        && window.MobileWebKit.engine === window.MobileWebKit.Engines.V200
        && { 'mobilewebkit-engine': '2.0.0' }),
    },
  },
  withCredentials: true,
};

module.exports = (options) => {
  const client = restclient(merge({}, DEFAULT_RESTCLIENT_OPTIONS, options));

  client.originalDoRequest = client.doRequest;
  /* istanbul ignore next */
  client.doRequest = function doRequest(args) {
    return this.originalDoRequest(args).catch((err) => {
      const res = err && err.response;
      if (res && res.status === 401 && res.data && res.data.data.login) {
        let stringLoginParams = '';
        if (args.loginParams) {
          stringLoginParams = `&${new URLSearchParams(args.loginParams).toString()}`;
        }
        window.location = `${res.data.data.login}${stringLoginParams}`;
        return;
      }
      if (res && res.status === 301 && res.data.location) {
        window.location = res.data.location;
      }

      throw err;
    });
  };

  return client;
};
